<div class="portal-link-item">
	<a
		class="portal-link"
		(mouseenter)="hover = true"
		(mouseleave)="hover = false"
		(click)="onOpen()"
		(auxclick)="onOpen()"
		draggable="false"
		nhaTest="portal-link"
		target="_blank"
		[href]="linkUrl"
	>
		<div class="portal-link-icon-container" [class.mat-elevation-z4]="hover" [ngStyle]="{ 'background-color': iconColor }">
			@if (iconSVG) {
				<i class="portal-link-icon svg" [innerHTML]="iconSVG | safe: 'html'"></i>
			}
			@if (iconClass) {
				<i class="portal-link-icon icon {{ iconClass }}"></i>
			}
			@if (iconLetters) {
				<i class="portal-link-icon letters {{ iconClass }}">{{ iconLetters | uppercase }}</i>
			}
		</div>
		<div class="app-name" nhaTest="portal-link-name" [innerHTML]="portalLinkName" [title]="portalLinkName"></div>
	</a>
	@if (!hideStar) {
		<button
			mat-icon-button
			class="favorite-button dense-3"
			[ngClass]="{ orange: isFavorite }"
			(click)="onToggleClick(!isFavorite)"
			[matTooltip]="isFavorite ? 'Remove favorite' : 'Add favorite'"
			[attr.aria-label]="(isFavorite ? 'Remove favorite: ' : 'Add favorite: ') + portalLinkName"
			[attr.aria-pressed]="isFavorite"
			nhaTest="favorite-button"
		>
			<mat-icon>
				{{ isFavorite ? 'star' : 'star_border' }}
			</mat-icon>
		</button>
	}
</div>
